// extracted by css-extract-rspack-plugin
export default {"tier-description":"gzCt2B","tierDescription":"gzCt2B"};